__turbopack_context__.v({
  "container": "DMRBua_container",
  "fullWidthImage": "DMRBua_fullWidthImage",
  "mainImage": "DMRBua_mainImage",
  "mobileCarousel": "DMRBua_mobileCarousel",
  "mobileCarouselContainer": "DMRBua_mobileCarouselContainer",
  "mobileDots": "DMRBua_mobileDots",
  "mobileImage": "DMRBua_mobileImage",
  "mobileSlide": "DMRBua_mobileSlide",
  "secondaryGrid": "DMRBua_secondaryGrid",
  "secondaryImage": "DMRBua_secondaryImage",
});
